import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitRtm = createSelector(
  [selectFinancialCockpitState],
  ({ selectedRtm }) => selectedRtm
)
